import { cn } from '@nesso/ui/lib/utils';
import { Button } from '@nesso/ui/primitives/button';
import { FieldDescription } from '@nesso/ui/primitives/field';

type Props = {
    id: string;
    hasError: boolean;
    onAddNewClient: () => void;
};

export function SearchClientHint({ id, hasError, onAddNewClient }: Props) {
    return (
        <FieldDescription id={id} role={hasError ? 'alert' : undefined}>
            {hasError ? 'Select or' : 'or'}{' '}
            <Button
                variant="link"
                onClick={onAddNewClient}
                className={cn(
                    'h-auto p-0 text-sm underline cursor-pointer font-normal align-baseline',
                    hasError ? 'text-destructive' : 'text-muted-foreground',
                )}
            >
                Add a new client
            </Button>
        </FieldDescription>
    );
}
